'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import I18n from 'I18n';
import { APP_NOTIFICATION } from 'DesignData/actions/ActionTypes';
export function i18nKey(key) {
  return `designdata.appNotifications.${key}`;
}
export function showAppNotification(notificationProps = {}) {
  const {
    type = 'info',
    sticky = false,
    timeout,
    titleText: _titleText,
    message: _message,
    notificationKey,
    titleTextProps = {},
    messageProps = {}
  } = notificationProps,
        rest = _objectWithoutPropertiesLoose(notificationProps, ["type", "sticky", "timeout", "titleText", "message", "notificationKey", "titleTextProps", "messageProps"]);

  const titleText = _titleText || I18n.text(i18nKey(`${notificationKey}.${type}.titleText`), titleTextProps);

  const message = _message || I18n.text(i18nKey(`${notificationKey}.${type}.message`), messageProps);

  return {
    type: APP_NOTIFICATION,
    meta: {
      notification: Object.assign({}, rest, {
        titleText,
        message,
        type,
        sticky,
        timeout
      })
    }
  };
}